module.exports = "<app-loader-com *ngIf=\"loading | async\"></app-loader-com>\n\n<div id=\"wrapper\">\n  <app-navigation-com></app-navigation-com>\n  <div id=\"page-wrapper\">\n    <router-outlet></router-outlet>\n  </div>\n  <app-footer-com></app-footer-com>\n</div>\n\n<app-snackbar-com></app-snackbar-com>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/app/app.com.html
// module id = ./src/app/com/app/app.com.html
// module chunks = main